import { render, staticRenderFns } from "./ButtonPlay.vue?vue&type=template&id=f0a85a8e"
import script from "./ButtonPlay.vue?vue&type=script&lang=js"
export * from "./ButtonPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports